<template>
  <div class="d-flex">
    <div class="quadrado bg-gray"></div>
    <span class="ml-2">Todas filiais agrupadas</span>

    <div class="ml-5 quadrado" style="background: rgba(255,140,0,.7)"></div>
    <span class="ml-2">Último produto analisado</span>

    <div class="ml-5 quadrado" style="background: rgba(5,140,0,.5);">
    </div>
    <span class="ml-2">Produtos que já estão no Carrinho de Compra</span>
  </div>
</template>

<script>
export default {
  name: "FooterPaginacao",
  model: {
    prop: 'page',
    event: 'mudar-page-selecionada'
  },
  props: {
  }
}
</script>

<style scoped>
.quadrado {
  height: 18px;
  width: 18px;
  border: 1px solid rgba(0,0,0,.15);
}
.bg-gray {
  background: #999;
}
</style>
